import { ReactNode } from 'react';

import classNames from 'classnames';

export const SIZES = ['md', 'lg', 'xl'] as const;
export type InputDisplaySizeType = (typeof SIZES)[number];

export type FormStateType = 'idle' | 'loading' | 'responded';
export type FormResponseType = 'success' | 'failure' | 'neutral';

export interface SharedInputProps {
  id: string;
  displaySize?: InputDisplaySizeType;
  invalid?: boolean;
  label?: ReactNode;
  hideLabel?: boolean;
  helpText?: ReactNode;
}

interface getInputClassNamesProps {
  displaySize: InputDisplaySizeType;
  invalid?: boolean;
  additional?: string;
  useDefaultMinHeight?: boolean;
}

export function getInputClassNames({
  displaySize,
  invalid,
  additional,
  useDefaultMinHeight = true,
}: getInputClassNamesProps) {
  return classNames(
    'block rounded-1 relative z-1 border w-full search-cancel:hidden',
    'focus:outline-none focus:ring focus-within:outline-none focus-within:ring',

    // sizes
    {
      'px-2': displaySize === 'md',
      'px-3': displaySize === 'lg',
      'px-4 py-3 text-body-450': displaySize === 'xl',
    },

    // Validation UI
    invalid
      ? 'text-red-600 bg-red-100 border-red-500 focus:ring-red-300'
      : 'text-black dark:text-paper bg-paper dark:bg-gray-800 border-primary focus:ring-cyan-400 focus-within:ring-cyan-400',

    // Min Height
    useDefaultMinHeight && {
      'min-h-button-md': displaySize === 'md',
      'min-h-button-lg': displaySize === 'lg',
    },

    // Pass through any additional classes
    additional,
  );
}
